var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#E25886"},React.createElement("g",{"transform":"translate(-318 -27) translate(318 27)"},[React.createElement("rect",{"width":"12","height":"2","rx":"1","key":0}),React.createElement("rect",{"width":"12","height":"2","y":"4","rx":"1","key":1}),React.createElement("rect",{"width":"12","height":"2","y":"8","rx":"1","key":2})]))));
}

Menu.defaultProps = {"width":"12","height":"10","viewBox":"0 0 12 10"};

module.exports = Menu;

Menu.default = Menu;
